import * as types from './mutations-types'

export default {
  [types.SET_READY](state, ready) {
    state.ready = ready
  },
  [types.OVERRIDE_SET_CUSTOM_FIELDS](state, customFields = []) {
    state.customFields = customFields
  },
  [types.SET_CUSTOM_FIELDS](state, customFields) {
    let _customFields = customFields

    if (customFields instanceof Array) {
      _customFields = customFields.reduce((obj, cf) => {
        obj[cf.id] = cf.value
        return obj
      }, {})
    }

    const fields = []

    if (_customFields && state.form) {
      for (let fieldId in _customFields) {
        const field = state.form.fields.find(f => f.fieldId === fieldId)

        if (field) {
          fields.push({
            value: _customFields[fieldId].fieldValue
              ? _customFields[fieldId].fieldValue
              : _customFields[fieldId],
            id: field.fieldId,
            domainType: field.domainType,
            title: field.title,
            type: field.type || field.fieldType
          })
        }
      }
    }

    if (fields.length) {
      state.customFields = fields
    } else {
      state.customFields = undefined
    }
  },
  [types.SET_COMPANY](state, company) {
    state.company = company
  },
  [types.SET_ORGANIZATION](state, organization) {
    state.organization = organization
  },
  [types.SET_EMBED_ID](state, id) {
    state.embedId = id
  },
  [types.SET_SETTINGS](state, settings) {
    state.settings = settings
  },
  [types.SET_FORM](state, form) {
    state.form = form
  },
  [types.TOGGLE_APP](state) {
    state.active = !state.active
  },
  [types.SET_FOCUS](state, value) {
    state.onFocus = value
  },
  [types.ACTIVE_APP](state) {
    state.active = true
  },
  [types.INACTIVE_APP](state) {
    state.active = false
  },
  [types.HIDE_APP](state, hide) {
    state.hiding = hide
  },
  [types.SET_PARENT_URL](state, url) {
    state.parentUrl = url
  },
  [types.SET_OPTIONS](state, options) {
    state.options = options
  },
  [types.SET_FILTER_AGENTS](state, value) {
    state.filterAgents = value
  },
  [types.SET_FETCHING_FORM](state, value) {
    state.fetchingForm = value
  },
  [types.SET_SUBDOMAIN_STATUS](state, value) {
    state.subDomainStatus = value
  },
  [types.SET_SUBDOMAIN_CULTURE](state, value) {
    state.culture = value || 'pt-BR'
  },
  [types.SET_WHITELABEL](state, whitelabel) {
    state.whitelabel = whitelabel
  }
}
